import { render, staticRenderFns } from "./exhibition-car-no.vue?vue&type=template&id=47aea38f&scoped=true&"
import script from "./exhibition-car-no.vue?vue&type=script&lang=js&"
export * from "./exhibition-car-no.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-car-no.vue?vue&type=style&index=0&id=47aea38f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aea38f",
  null
  
)

export default component.exports